<template>
    <v-app>
        <v-layout wrap>
            <v-flex>
                <v-card v-if="isLoading" dark height="100%">
                    <loading 
                        :active.sync="isLoading" 
                        loader="dots"
                        color="#ff7a7a"
                        backgroundColor="#666"
                        width="45"
                    ></loading>
                </v-card>
                <v-card v-else dark height="100%">
                    <v-card-title class="avatar pb-0">
                            <v-list-tile-avatar class="mx-auto" size="70" color="grey darken-3">
                                <v-img class="elevation-12" :src="profile.pictureUrl"></v-img>
                            </v-list-tile-avatar>
                    </v-card-title>
                    <v-card-text class="font-weight-bold text-xs-center" >
                        <h3 class="mb-2">{{profile.displayName}}</h3>
                        <div class="d-flex cardBody">
                            <div v-if="dyson">
                                <p class="title font-weight-light mb-1">你已經成功邀請</p>
                                <span style="font-size:34px">{{fight}}</span>
                                <p class="title font-weight-light">個新好友</p>
                            </div>
                            <div v-else>
                                <span>{{fight}}</span>
                                <p class="title font-weight-light">{{success_invite_name}}</p>
                            </div>
                            <div v-if="!dyson">
                                <span>{{total_award_count}}</span>
                                <p class="title font-weight-light">總抽獎<br/>次數</p>
                            </div>
                            <div v-if="!dyson">
                                <span>{{award_count}}</span>
                                <p class="title font-weight-light">可抽獎<br/>次數</p>
                            </div>
                        </div>
                        <v-btn
                            v-if="!dyson && award_url!==''"
                            class="mx-2 my-1 font-weight-bold"
                            color="teal lighten-2"
                            style="letter-spacing:2px"
                            @click="goPage(award_url)"
                        >
                            抽獎去
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

    </v-app>
</template>

<script>
var lambda_url = process.env.VUE_APP_SLS_HOST
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {
        Loading
    },
    data () {
        return {
            fight: 0,
            profile: {},
            company: '',
            award_url: '',
            award_count: 0,
            total_award_count: 0,
            success_invite_name: '成功邀請人數',
            isLoading: false,
            //Dyson Customization
            dyson: false
        }
    },
    created() {
        // let params = new URLSearchParams(window.location.search.substring(1));
        // this.company = params.get('company')

        // liff.init((data) => { 
        //     this.getProfile()
        // })
    },
    mounted(){
        this.isLoading = true;
        let params = new URLSearchParams(window.location.search.substring(1));
        let liffId = params.get("lid");
        let liffState = params.get("liff.state");

        if (liffState != undefined) {
            let sp = new URLSearchParams(liffState.split("?")[1]);
            liffId = sp.get("lid");
            this.company = sp.get("company")

        } else {
            this.company = params.get('company')
        }

        //dyson Costomization
        //1653870156-mdGDkkPL prod's test
        if( ["1593482940-j464nJAJ", "1653870156-mdGDkkPL"].includes(liffId) ){
            this.dyson = true
            document.title = "Dyson 好友推薦活動"
        }else{
            document.title = "成就看板"
        }

        const initLiff = async () => {
            try {
                console.log(liffId)
                await liff.init({ liffId: liffId });
                if (!liff.isLoggedIn()) {
                    liff.login({ redirectUri: window.location.href });
                }

                const context = liff.getContext();
                this.userId = context.userId;
                this.profile = context
                console.log(this.profile)
                await this.get_fight()
                setTimeout(() => {
                    this.isLoading = false
                }, 2000);
            } catch (err) {
                console.log(`liff.state init error ${err}`);
            }
        }

        initLiff();
    },
    methods: {
        // getProfile() {
        //     liff.getProfile().then((profile) => {
        //         this.profile = profile
        //         this.get_fight()
        //     })
        // },
        get_fight() {
            
            let data_post = {}
            data_post = {
                profile: this.profile,
                company: this.company,
            }
            console.log(data_post)
            console.log(lambda_url)
            // axios.post('https://5qhaye3cne.execqute-api.ap-southeast-1.amazonaws.com/dev/get_fight', data_post)
            axios.post(lambda_url+"get_fight/", data_post)
            .then(reponse => {
                var tmp = reponse.data   
                if(tmp.status == true){
                    console.log(tmp)
                    this.profile = tmp.profile
                    this.fight = tmp.fight
                    this.total_award_count = tmp.total_award_count
                    this.award_url = tmp.award_url
                    this.award_count = tmp.award_count
                    this.success_invite_name = tmp.success_invite_name
                }
                else
                    alert('404')
            })
            .catch(function (error) {
            })
        },
        goPage(url){
            window.location = url
        }
    },
}
</script>
<style scoped>
.cardBody div{
    width: 30%;
    padding: 10px 16px;
}
.cardBody div span{
    font-size: 26px;
}
.cardBody div p{
    margin-top: 4px;
    line-height: 28px !important;
}
</style>